import { PropsWithChildren } from 'react';
import cn from 'classnames';
import GosuslugiLogoIcon from 'shared/icons/gosuslugi-logo.svg';
import styles from './gosuslugi-button.module.scss';

type GosuslugiButtonProps = PropsWithChildren & {
  forceCompact?: boolean;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
};

export const GosuslugiButton = ({ forceCompact, className, disabled, onClick }: GosuslugiButtonProps) => {
  /* TODO: заменить на компонент ui-kit */
  //или добавить cursor: pointer
  return (
    <button type="button" onClick={onClick} disabled={disabled} className={cn(styles.gosuslugiButton, className)}>
      {!forceCompact && (
        <>
          <img className={styles.hugeIcon} src={GosuslugiLogoIcon} alt="" width={44} height={44} />
          <img className={styles.compactIcon} src={GosuslugiLogoIcon} alt="" width={24} height={24} />
        </>
      )}
      {forceCompact && <img src={GosuslugiLogoIcon} alt="" width={24} height={24} />}
      Заполнить{'\u00A0'}через{'\u00A0'}Госуслуги
    </button>
  );
};
